import './HomePage.css';
import React from 'react';

const HomePage = () => {
  const img_src1 = process.env.PUBLIC_URL + '/feat-1.png';
  const img_src2 = process.env.PUBLIC_URL + '/feat-2.png';
  /*const img_src3 = process.env.PUBLIC_URL + '/features1.png';
  const img_src4 = process.env.PUBLIC_URL + '/features2.png';*/
  const hero_video = process.env.PUBLIC_URL + '/fashion-bg.mp4';
  /*const video_src = process.env.PUBLIC_URL + '/haute-u-AR.mp4'; */

  return (
    <div id="Home" className="home-page">

      {/* HERO SECTION WITH VIDEO BACKGROUND */}
      <div className="hero-video-section">
        <video autoPlay muted loop playsInline>
          <source src={hero_video} type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-text">
            <h1>Fashion Meets AI</h1>
            <p>
              Discover a smarter way to shop with Haute-u AR — where artificial intelligence meets personal styling.
              Try on virtually, match outfits to your body and skin tone, and feel runway-ready from anywhere.
            </p>
            <button className="cta-button" onClick={() => window.location.href = 'https://apps.hauteuar.com'}>
              Try On Now
            </button>
          </div>

          <div className="hero-media">
            <img src={img_src1} alt="Try-On 1" />
            <img src={img_src2} alt="Try-On 2" />
            
          </div>
        </div>
      </div>

      {/* KEY FEATURES */}
      <div id="features" className="features-container">
        <h1 style={{ textAlign: 'center' }}>Key Features</h1>
        <div className="feature-quadrants">
          <div className="feature">
            <img src={process.env.PUBLIC_URL + '/skin-tone-icon.png'} alt="Skin Tone Analysis" />
            <h2>Skin Tone-Based Fashion Recommendations</h2>
            <p>AI-driven color and style suggestions to complement your natural beauty.</p>
          </div>
          <div className="feature">
            <img src={process.env.PUBLIC_URL + '/virtual-measurement-icon.png'} alt="Virtual Measurement" />
            <h2>Virtual Body Measurement</h2>
            <p>Get precise measurements instantly for a perfect fit every time.</p>
          </div>
          <div className="feature">
            <img src={process.env.PUBLIC_URL + '/body-type-icon.png'} alt="Body Type Analysis" />
            <h2>Body Type Analysis</h2>
            <p>Personalized outfit recommendations based on your body shape.</p>
          </div>
          <div className="feature">
            <img src={process.env.PUBLIC_URL + '/ai-chat-icon.png'} alt="AI Chat" />
            <h2>AI Chat for Personalized Fashion Advice</h2>
            <p>Get expert guidance on outfits, styles, and trends tailored for you.</p>
          </div>
        </div>
      </div>
    </div>
    
  );

};

export default HomePage;
